<template>
  <v-autocomplete
    v-model="select"
    :items="items"
    :filter="filter"
    :label="label"
    item-value="code"
    :error-messages="errorMessages"
    :clearable="clearable"
  >
    <template v-slot:selection="data">
      <country-flag :country="data.item.code" size="normal" class="normal-flag-move" />
      {{ data.item.name }}
    </template>
    <template v-slot:item="data">
      <country-flag :country="data.item.code" size="normal" class="normal-flag-move" />
      {{ data.item.name }}
    </template>
  </v-autocomplete>
</template>

<script>
/*
 * model input value format:
 *   country
 */
export default {
  name: "CountryField",

  props: {
    value: {
      type: String
    },
    preferred: {
      type: Array,
      default: () => [ "CZ", "SK", "HU", "DE", "AT", "PL" ]
    },
    label: {
      type: String,
      mandatory: true
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      select: null,
      search: null
    };
  },

  methods: {
    filter(item, queryText) {
      if (item.divider)
        return true;

      const qtext = queryText.toLowerCase()
      return item.code.toLowerCase().indexOf(qtext) > -1
        || item.name.toLowerCase().indexOf(qtext) > -1;
    },

    setValue(value) {
      this.select = value;
    }
  },

  watch: {
    select: function() {
      this.$emit("input", this.select);
    },

    value: function() {
      this.setValue(this.value);
    }
  },

  computed: {
    items: function() {
      if (this.preferred) {
        const preferredCountries = this.$store.state.data.listCountries
          .filter(item => item.continentCode === "EU" && this.preferred.includes(item.code))
          .sort((a, b) => (a.name > b.name ? 1 : -1));

        return [...preferredCountries, { divider: true }, ...this.$store.state.data.listCountries
          .filter(item => item.continentCode === "EU" && !this.preferred.includes(item.code))
          .sort((a, b) => (a.name > b.name ? 1 : -1))];
      } else {
        return this.$store.state.data.listCountries
          .filter(item => item.continentCode === "EU")
          .sort((a, b) => (a.name > b.name ? 1 : -1));
      }
    }
  },

  mounted() {
    this.$store.dispatch("data/fetchCodes", "countries");

    this.setValue(this.value);
  }
};
</script>

<style lang="sass" scoped>
.normal-flag-move
  margin: -10px -5px !important
</style>